module.exports = __webpack_public_path__ + "b8b04e181c12a3fff45e8e04a59c0d4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folder_icon_2x.png
// module id = 124
// module chunks = 0 1 2 3 4